import React from 'react';
import wb0 from '../img/Detail/mjcare-detail.jpg';
import './Detail.css';
const MjcareDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default MjcareDetail;